import React from "react";
import NotificationItem from "./NotificationItem";
import TitleBar from "./TitleBar";
import { dateToTimeString, dateToRelativeString } from "../utils/DateHelper";

class NotificationsPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let notificationIndex = -1;

    const { account, notifications } = this.props;

    let lastDate = null;

    const items = notifications.map(v => {
      const data = v.data();
      notificationIndex++;

      let showDate = false;
      const dateString = dateToRelativeString(data.created.toDate());
      if (dateString !== lastDate) {
        showDate = true;
        lastDate = dateString;
      }

      return (
        <div key={v.id}>
          {showDate ? <TitleBar small title={dateString} /> : null}
          <NotificationItem
            account={account}
            index={notificationIndex}
            id={v.id}
            read={data.read}
            clientId={data.client}
            message={getNotificationMessage(data)}
            time={dateToTimeString(data.created.toDate())}
            type="good"
            action="Kunden anzeigen"
            actionUrl={`/dash/clients/${data.client}`}
          />
        </div>
      );
    });

    return <div className="NotificationsPanel">{items}</div>;
  }
}

export default NotificationsPanel;

function getNotificationMessage(n) {
  switch (n.type) {
    case "sent_approval_request":
      return `Dem Kunden wurde eine E-Mail mit einem Link zum Projekt gesendet.`;
    default:
      return n.type;
  }
}



// WEBPACK FOOTER //
// ./src/components/NotificationsPanel.js